import { Box, Grid, Link, Typography, useMediaQuery } from "@mui/material";
import { grey } from "@mui/material/colors";
import profile from "assets/splashpage/profile.jpg";
import { ReactNode } from "react";

import {
  BRAND_LANDING_PAGE_LINK,
  LANDING_PAGE_LINK,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface LayoutProps {
  children: ReactNode;
  isBrand?: boolean;
}

const InfluencerLayout = ({ isBrand = false, children }: LayoutProps) => {
  const isMobileScreen = useMediaQuery("(max-width:980px)");

  const goToLandingPage = () => {
    trackEvent("Landing Page Logo Clicked", {
      "Clicked From": "Login/Signup Page",
    });
    window.open(isBrand ? BRAND_LANDING_PAGE_LINK : LANDING_PAGE_LINK, "_self");
  };

  if (isMobileScreen) {
    return (
      <Grid container sx={styles.mobilePage}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography textAlign="center" sx={styles.mobileHeader}>
            Automate brand pitching with{" "}
            <Box component="span">
              <Link
                sx={{
                  color: "yellow.main",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={goToLandingPage}
              >
                Bento
              </Link>
            </Box>
          </Typography>

          <Grid container gap={1} justifyContent="center" sx={{ mb: 2 }}>
            <Box sx={styles.mobileCard}>🤝 750k+ Brand Contacts</Box>
            <Box sx={styles.mobileCard}>🔔 Automated Follow-Ups</Box>
            <Box sx={styles.mobileCard}>✍️ Customized Pitch Templates</Box>
          </Grid>

          {children}
          <Typography
            textAlign="center"
            sx={{ color: "white", mt: 2, fontSize: 12 }}
          >
            💥 <strong>Sign Up Today</strong> and get{" "}
            <Box component="span" sx={{ fontSize: 14, color: "#93F288" }}>
              25% off
            </Box>{" "}
            within your first month
          </Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent={"center"}>
      <Grid container sx={styles.page}>
        <Grid container item xs sx={styles.signUpFormContainer}>
          <Grid>
            {children}
            <Typography sx={styles.text}>
              💥 <strong>Sign Up Today</strong> and get 25% off within your
              first month
            </Typography>
          </Grid>
        </Grid>

        <Grid sx={styles.image} item xs={12} md={6}>
          <Grid
            container
            item
            sx={{ p: 1, pt: 4 }}
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <Box sx={styles.card}>
              <Box
                sx={[styles.littleCircle, { backgroundColor: "green.light" }]}
              />
              <Box sx={{ fontSize: 20 }}>750k+</Box> Brand Contacts Worldwide
            </Box>

            <Box sx={[styles.card]}>
              <Box
                sx={[styles.littleCircle, { backgroundColor: "purple.main" }]}
              />
              <Box sx={{ fontSize: 20 }}>Automated</Box>
              Follow-Ups On Your Behalf
            </Box>
            <Box sx={[styles.card]}>
              <Box
                sx={[styles.littleCircle, { backgroundColor: "#b9a311ff" }]}
              />
              <Box sx={{ fontSize: 20 }}>Customized</Box>
              Pitch Templates that Convert
            </Box>
          </Grid>
          <Grid item xs={12} sx={styles.content}>
            <Typography sx={styles.header}>
              Put your brand pitching on autopilot with{" "}
              <Box component="span">
                <Link
                  sx={{
                    color: "yellow.main",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={goToLandingPage}
                >
                  Bento
                </Link>
              </Box>
            </Typography>

            <Grid
              container
              item
              xs
              sx={styles.glass}
              gap={1.5}
              alignItems={"center"}
            >
              <Grid item xs="auto">
                <Box
                  component={"img"}
                  src={profile}
                  sx={{ height: 80, borderRadius: 2 }}
                />
              </Grid>
              <Grid item xs>
                <Typography sx={{ color: "white", fontSize: 12 }}>
                  I get all my students started on bento - in fact the comment
                  section here is FULL of their stories. I have{" "}
                  <Box
                    component="span"
                    sx={{ fontSize: 14, color: "purple.main" }}
                  >
                    students earning anywhere from $1000 - $4000
                  </Box>{" "}
                  within their first month of pitching all because of bento
                </Typography>

                <Typography sx={{ fontSize: 12, mt: 1, color: "white" }}>
                  <strong>Sydney Mohni</strong>
                </Typography>
                <Typography sx={{ fontSize: 12, color: grey[500] }}>
                  UGC Creator & Coach
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InfluencerLayout;
